import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { PublicContainer } from "../common/components";

import CreateAccountView from "./public/CreateAccountView";
import ForgotPasswordView from "./public/ForgotPasswordView";
import LoginView from "./public/LoginView";
import ResetPasswordView from "./public/ResetPasswordView";
import ResetOTPView from "./public/ResetOTPView";

const PublicRoutes = (): JSX.Element => {
    return (
        <PublicContainer>
            <Switch>
                <Route path="/login" component={LoginView} />
                <Route path="/forgot-password" component={ForgotPasswordView} />
                <Route
                    path="/reset-password/:token"
                    component={ResetPasswordView}
                />
                <Route
                    path="/reset-2fa/:token"
                    component={ResetOTPView}
                />
                <Route
                    path="/create-account/:token"
                    component={CreateAccountView}
                />
                <Redirect to="/login" />
            </Switch>
        </PublicContainer>
    );
};

export default PublicRoutes;
